import React from 'react';
import { Hero } from '../components/sections/Hero';
import { NarrativeBlock } from '../components/sections/NarrativeBlock';
import { TargetAudience } from '../components/sections/TargetAudience';
import { Benefits } from '../components/sections/Benefits';
import { Mechanism } from '../components/sections/Mechanism';
import { PackageIncludes } from '../components/sections/PackageIncludes';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { CTAButton } from '../components/ui/CTAButton';
import { ContentSection } from '../components/ui/ContentSection';
import { motion } from 'framer-motion';
export function LandingPage() {
  return <main className="min-h-screen bg-[#FAFAFA] text-[#1A1A1A] font-sans selection:bg-amber-100 selection:text-amber-900" data-id="element-192">
      <Hero data-id="element-193" />

      <NarrativeBlock label="IDENTIFICACIÓN / ESPEJO" title="El cansancio que no se quita durmiendo" background="white" image="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766234477/Gemini_Generated_Image_j5wmbkj5wmbkj5wm_yif0an.png" imageAlt="Visualización del cansancio y dispersión" imagePosition="right" data-id="element-194">
        <p data-id="element-195">
          Tienes resultados.
          <br data-id="element-196" />
          Tienes disciplina.
          <br data-id="element-197" />
          Tienes talento.
        </p>
        <p className="my-6" data-id="element-198">Y aun así:</p>
        <p className="ml-4" data-id="element-199">
          — el día no alcanza
          <br data-id="element-200" />
          — la cabeza no descansa
          <br data-id="element-201" />— Siempre faltan cosas por hacer
        </p>
        <p className="font-bold text-gray-900 text-xl my-6" data-id="element-202">
          No es falta de motor.
          <br data-id="element-203" />
          Es falta de claridad.
        </p>
        <p data-id="element-204">
          Y la claridad no se desea.
          <br data-id="element-205" />
          Se diseña.
        </p>
      </NarrativeBlock>

      <NarrativeBlock label="PROBLEMA CENTRAL" title="La verdad incómoda que casi nadie te dice" background="gray" data-id="element-206">
        <p data-id="element-207">
          Hacer más ya no es la respuesta. De hecho, hacer más desde el mismo
          nivel suele provocar más presión, menos claridad, menos energía y la
          sensación de correr sin avanzar.
        </p>
        <p className="text-xl font-medium text-gray-900 mt-6" data-id="element-208">
          El avance real no se improvisa. Se diseña. Y se protege.
        </p>
      </NarrativeBlock>

      <NarrativeBlock label="REVELACIÓN" title="El techo invisible" background="white" image="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766234477/Gemini_Generated_Image_noqzcmnoqzcmnoqz_ffp9yb.png" imageAlt="Concepto del techo invisible" imagePosition="left" data-id="element-209">
        <p data-id="element-210">
          Llega un punto —especialmente si eres responsable— en el que aparece
          un techo. No es falta de talento. No es falta de disciplina. No es
          falta de ganas.
        </p>
        <p className="my-6" data-id="element-211">
          Es un techo invisible. Trabajas más… pero el crecimiento deja de
          sentirse proporcional. Ahí es donde muchas personas se frustran. O se
          resignan.
        </p>
        <p className="font-bold text-amber-600" data-id="element-212">
          Y otras deciden subir de nivel.
        </p>
      </NarrativeBlock>

      <NarrativeBlock label="PREGUNTA BISAGRA" title="La pregunta que lo cambia todo" background="gray" highlight data-id="element-213">
        <p className="text-xl mb-6" data-id="element-214">
          Hay una pregunta incómoda, pero ordenadora:
        </p>
        <h3 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-215">
          ¿Cuánto vale una hora de tu vida?
        </h3>
        <p data-id="element-216">
          Porque cuando no sabes cuánto vale tu hora: la regalas, la llenas de
          cosas que no suman, la entregas a lo urgente y la postergas por
          costumbre.
        </p>
        <p className="mt-6 font-medium" data-id="element-217">
          Y sin darte cuenta, no pierdes un día. Pierdes años.
        </p>
      </NarrativeBlock>

      <ContentSection background="white" data-id="element-218">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-219">
          <div data-id="element-220">
            <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-221">
              SOLUCIÓN
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6" data-id="element-222">
              Esto no es motivación. <br data-id="element-223" />
              <span className="text-gray-500" data-id="element-224">Es un sistema de claridad.</span>
            </h2>
            <div className="prose prose-lg text-gray-600 mb-8" data-id="element-225">
              <p data-id="element-226">
                <strong data-id="element-227">Juega Desde Otro Nivel</strong> no es un libro para
                empujarte a aguantar más. Es un libro para ayudarte a ver con
                claridad, ordenar decisiones, proteger tu energía y enfocar tu
                tiempo.
              </p>
              <p data-id="element-228">
                No se trata de trabajar menos. Se trata de trabajar desde otro
                nivel.
              </p>
            </div>
            <CTAButton href="https://coneckta.co/ebookjuegadesdeotronivel" data-id="element-229">
              Quiero jugar desde otro nivel
            </CTAButton>
          </div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative" data-id="element-230">
            <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766234477/Gemini_Generated_Image_j7ylibj7ylibj7yl_rz5r9k.png" alt="Libro Juega Desde Otro Nivel" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-231" />
          </motion.div>
        </div>
      </ContentSection>

      <TargetAudience data-id="element-232" />

      <Benefits data-id="element-233" />

      <Mechanism data-id="element-234" />

      <ContentSection background="white" data-id="element-235">
        <div className="text-center max-w-3xl mx-auto" data-id="element-236">
          <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-237">
            CÓMO SE USA
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-8" data-id="element-238">
            ¿Cómo se usa este libro?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-239">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-240">
              <span className="text-amber-500 font-bold text-xl block mb-2" data-id="element-241">
                01
              </span>
              <p className="font-medium text-gray-900" data-id="element-242">
                Lo lees en bloques cortos
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-243">
              <span className="text-amber-500 font-bold text-xl block mb-2" data-id="element-244">
                02
              </span>
              <p className="font-medium text-gray-900" data-id="element-245">
                Cada capítulo incluye una pregunta clave
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-246">
              <span className="text-amber-500 font-bold text-xl block mb-2" data-id="element-247">
                03
              </span>
              <p className="font-medium text-gray-900" data-id="element-248">
                Aplicas el filtro el mismo día
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-249">
              <span className="text-amber-500 font-bold text-xl block mb-2" data-id="element-250">
                04
              </span>
              <p className="font-medium text-gray-900" data-id="element-251">
                No necesitas terminarlo para ver claridad
              </p>
            </div>
          </div>
          <p className="mt-8 text-xl font-medium text-gray-900" data-id="element-252">
            Diseñado para personas ocupadas. Pensado para aplicar, no acumular.
          </p>
        </div>
      </ContentSection>

      <PackageIncludes data-id="element-253" />

      <FAQ data-id="element-254" />

      <FinalCTA data-id="element-255" />

      <footer className="bg-[#FAFAFA] py-12 text-center text-gray-400 text-sm" data-id="element-256">
        <p data-id="element-257">
          © {new Date().getFullYear()} Juega Desde Otro Nivel. Todos los
          derechos reservados.
        </p>
      </footer>
    </main>;
}